module.exports = __webpack_public_path__ + "static/img/notify.0ecdcd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notify.png
// module id = CAPw
// module chunks = 1